import { Grid, Tooltip } from "@mui/material";

interface IShortDescriptionProps {
  description: string;
  length?: number;
}

export const ShortDescription = (props: IShortDescriptionProps): JSX.Element => {
  const { description } = props;
  return (
    <Tooltip enterTouchDelay={300} title={description}>
      <Grid item xs container spacing={0} sx={{ width: "100%" }}>
        <Grid item zeroMinWidth xs sx={{ whiteSpace: "nowrap", overflowX: "hidden", textOverflow: "ellipsis" }}>
          {description}
        </Grid>
      </Grid>
    </Tooltip>
  );
};
